/* eslint-disable react/jsx-no-bind */
import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import {
    AvailabilityDatePickerContainer,
    DatePickerInlineMessage,
} from '@homeaway/react-availability-date-picker';

import StayContext from '../../../../context/StayContext';
import SystemContext from '../../../../context/SystemContext';
import translate from '../../../../../utils/translations';
import datesUtil from '../../../../../utils/dates';
import calendarAlertTypes from '../../../../../utils/calendarAlertTypes';
import calendarLabels from './calendarLabels';
import {
    MODIFY_BOOKING,
    uxDatePickerPresented,
    uxDatePickerHidden,
    uxDatesVisibleAdjusted,
} from '../../../../../utils/EDAP/ConversationDetails';

export default function ModifyBookingAvailabilityCalendar(props) {
    const {
        system: {fullLocale},
    } = useContext(SystemContext);
    const {
        stay: {
            booking: {
                arrival: existingCheckInDate,
                departure: existingCheckOutDate,
            },
        },
    } = useContext(StayContext);

    const {
        checkInDate,
        checkOutDate,
        minStayRange,
        setUpdatedDates,
        stayAvailability,
        translations,
    } = props;
    const locale = datesUtil.getLocale(fullLocale);
    const actionLocation = MODIFY_BOOKING;

    const onDatepickerClose = () => uxDatePickerHidden({actionLocation});
    const onDatepickerOpen = () => uxDatePickerPresented({actionLocation});

    const onCancel = (newCheckInDate, newCheckOutDate) => {
        if (!newCheckInDate || !newCheckOutDate) {
            setUpdatedDates({
                newCheckInDate: existingCheckInDate,
                newCheckOutDate: existingCheckOutDate,
            });
        }
    };

    const onSubmit = (newCheckInDate, newCheckOutDate) => {
        if (
            checkInDate !== newCheckInDate ||
            checkOutDate !== newCheckOutDate
        ) {
            uxDatesVisibleAdjusted({
                actionLocation,
                startDate: newCheckInDate,
                endDate: newCheckOutDate,
            });
        }

        setUpdatedDates({
            newCheckInDate: newCheckInDate || existingCheckInDate,
            newCheckOutDate: newCheckOutDate || existingCheckOutDate,
        });
    };

    const alertOverrideData = {
        alertLevel: calendarAlertTypes.INFO,
        primaryMessage: translate(
            translations,
            'traveler/listing',
            'messages',
            'datepicker.datesAvailable'
        ),
        showAlert: true,
    };
    const availabilityCalendar = {availability: stayAvailability};
    const minStayDefault = stayAvailability?.minStayDefault || 0;

    const {minStayLow, minStayHigh} = minStayRange;

    const labels = calendarLabels(translations, {
        minStayLength: minStayDefault,
    });

    return (
        <div
            className="ModalRequest__trip-details--dates"
            data-testid="modify-booking-availability-calendar"
        >
            <AvailabilityDatePickerContainer
                availabilityCalendar={availabilityCalendar}
                alertTemplateComponent={DatePickerInlineMessage}
                alertTemplateDataOverride={alertOverrideData}
                centered
                clearButtonLabel={translate(
                    translations,
                    'traveler/listing',
                    'messages',
                    'property.clear.dates'
                )}
                continueButtonLabel={translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.buttons.continue'
                )}
                closeButtonLabel={translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.buttons.close'
                )}
                endDate={checkOutDate}
                id={'stay-availability-date-picker-container'}
                inputName1={'checkin'}
                inputName2={'checkout'}
                labels={labels}
                locale={locale}
                minStayRange={{minStayLow, minStayHigh}}
                onCancel={onCancel}
                onClose={onDatepickerClose}
                onOpen={onDatepickerOpen}
                onSubmit={onSubmit}
                startDate={checkInDate}
            />
        </div>
    );
}

ModifyBookingAvailabilityCalendar.propTypes = {
    checkInDate: PropTypes.string,
    checkOutDate: PropTypes.string,
    minStayRange: PropTypes.shape({
        minStayLow: PropTypes.number,
        minStayHigh: PropTypes.number,
    }),
    setUpdatedDates: PropTypes.func,
    stayAvailability: PropTypes.shape({}),
    translations: PropTypes.shape({}).isRequired,
};
